export default __webpack_public_path__ + "static/media/Category-T-Carpet Tiles.325dc694.jpg";